module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "ch1"
    }
  }), _vm._v("CHAPTER 1")]), _vm._v(" "), _c('h2', {
    staticClass: "section_hd"
  }, [_vm._v("LARDER")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0014-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#pg17lev1"
    }
  }, [_c('em', [_vm._v("Preserved kumquats with lime and chile")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#pg17lev1"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#pg18lev1"
    }
  }, [_c('em', [_vm._v("Preserved kumquat vinaigrette")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#pg18lev1"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#pg21lev1"
    }
  }, [_c('em', [_vm._v("Hoja santa vinaigrette")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#pg21lev1"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12chapter05#pg22lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Cascabel-thyme vinaigrette")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/12chapter05#pg22lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13chapter06#pg23lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Carrot escabeche")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/13chapter06#pg23lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14chapter07#pg24lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Habanero pickle")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/14chapter07#pg24lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15chapter08#pg25lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Pickled oregano onions")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/15chapter08#pg25lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16chapter09#pg27lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Pickled gooseberries")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/16chapter09#pg27lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17chapter10#pg28lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Mexican salmorejo")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/17chapter10#pg28lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18chapter11#pg29lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Mexican sriracha")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/18chapter11#pg29lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19chapter12#pg31lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Morita-guajillo salsa")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/19chapter12#pg31lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20chapter13#pg32lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Amá spice mix")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/20chapter13#pg32lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21chapter14#pg34lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Soldadera’s hot sauce")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/21chapter14#pg34lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22chapter15#pg35lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Jesusita’s pequín salsa")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/22chapter15#pg35lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23chapter16#pg36lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Red-eye spice")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/23chapter16#pg36lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24chapter17#pg37lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Salsa de aguacate")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/24chapter17#pg37lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25chapter18#pg38lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Pine nut and tepin salsa")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/25chapter18#pg38lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26chapter19#pg41lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Cobjini")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/26chapter19#pg41lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27chapter20#pg43lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Tomatillo salsa")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/27chapter20#pg43lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28chapter21#pg44lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Charred green-onion crema")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/28chapter21#pg44lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "chtoc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29chapter22#pg47lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Cascabel pimento cheese")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/29chapter22#pg47lev1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("47")])])]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0015-01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-341b6a98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08chapter01.vue
// module id = 81
// module chunks = 0